import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './assets/styles.scss';

const cx = classNames.bind(styles);

export default function GridCard({ children, className, isLoading }) {
  return (
    <div className={`${cx('grid-card', { skeleton: isLoading })} ${className}`}>{isLoading ? null : children}</div>
  );
}
GridCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  className: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
